<button class="am-key text-center {{ isDarkTheme? 'am-dark-theme': 'am-light-theme' }} txt-Garnett-Semibold "
        [ngClass]="getClass(key)"
        [disabled]="key.disabled"
        (mousedown)="$event.preventDefault()"
        (click) ="onPressKey(key)"
        *ngIf="!key.key.includes('aux') || key.key === '' else aux"
        >
    <span *ngIf="!(key.key === 's' || key.key === '\r' || key.key === '\tr' || key.key === 'aux1' || key.key === 'aux2'|| key.key === 'hide' )">{{ key.description | translate }}</span>
    <span *ngIf="key.key === '\tr'"><i class="fas fa-backspace"></i></span>
    <span *ngIf="key.key === '\r'"><i class="fas fa-level-down-alt fa-rotate-90"></i></span>
  <div *ngIf="key.key === 'hide'" class="AMKeyBoard_hide"></div>
</button>
<ng-template #aux>
    <div class="txt-Garnett-Semibold" [ngClass]="getClass(key)">
        <span *ngIf="key.key === 'aux1' || key.key === 'aux2'"></span>
    </div>
</ng-template>

